(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-fullscreen-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var video = document.getElementById('custom-fsvideo-player');
  var toggle = document.getElementById('custom-fsvideo-toggle');
  if (!video || !toggle) return;

  toggle.addEventListener('click', function () {
    video.muted = !video.muted;
    if (!video.muted) {
      video.volume = 1;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
    toggle.querySelector('.icon-muted').style.display = video.muted ? '' : 'none';
    toggle.querySelector('.icon-unmuted').style.display = video.muted ? 'none' : '';
    toggle.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var galleries = document.querySelectorAll('.custom-pgallery');
  galleries.forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    if (!thumbs.length || !slides.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var slide = gallery.querySelector('[data-gallery-slide="' + index + '"]');
        if (slide) slide.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  var video = document.getElementById('custom-video-showcase-player');
  var toggle = document.getElementById('custom-video-showcase-toggle');
  if (!video || !toggle) return;

  toggle.addEventListener('click', function () {
    video.muted = !video.muted;
    if (!video.muted) {
      video.volume = 1;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
    toggle.querySelector('.icon-muted').style.display = video.muted ? '' : 'none';
    toggle.querySelector('.icon-unmuted').style.display = video.muted ? 'none' : '';
    toggle.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
